export const UPDATE_BUY_QUANTITY = 'product/UPDATE_BUY_QUANTITY'
export const UPDATE_PRODUCT = 'product/UPDATE_PRODUCT'
// export const UPDATE_STORE_ID_LIST = 'stores/UPDATE_STORE_ID_LIST'


export const UPDATE_BUY_PRODUCTS = 'shoppingProgress/UPDATE_BUY_PRODUCTS'

export const UPDATE_SHOPPING_COUNT = 'headerBar/UPDATE_SHOPPING_COUNT'